import { render, staticRenderFns } from "./rulesDialog.vue?vue&type=template&id=37795fda&scoped=true&"
import script from "./rulesDialog.vue?vue&type=script&lang=js&"
export * from "./rulesDialog.vue?vue&type=script&lang=js&"
import style0 from "./rulesDialog.vue?vue&type=style&index=0&id=37795fda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37795fda",
  null
  
)

export default component.exports